import { render, staticRenderFns } from "./HoldingExposureChart.vue?vue&type=template&id=764269d8&"
import script from "./HoldingExposureChart.vue?vue&type=script&lang=js&"
export * from "./HoldingExposureChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports